<script lang="ts">
import { computed, defineComponent } from 'vue'

import { opChain } from '@collector/shared-utils'
import { CricketIncidentId } from '@collector/sportsapi-client-legacy'
import Button from '@mobile/components/Button/Button.vue'
import IncidentButton from '@mobile/views/Relation/Shared/IncidentButton/IncidentButton.vue'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import { useCricketConfiguration } from '@mobile/views/Relation/Sports/Cricket/CricketRelationDependencies/useCricketConfiguration'

import { useShowBattersAndBowlerSwitch } from '../../useShowBattersAndBowlerSwitch'
import CurrentBattersAndBowlerDisplayInfo from '../CurrentBatters/CurrentBattersAndBowlerDisplayInfo.vue'
import CurrentBattersAndBowlerSelection from '../CurrentBatters/CurrentBattersAndBowlerSelection.vue'
import { resolveBowlerRunningDisabled } from '../resolveBowlerRunningDisabled'
import { resolveStartOverIncidentEnabled } from '../resolveStartOverIncident'

export default defineComponent({
  components: {
    IncidentButton,
    CurrentBattersAndBowlerSelection,
    CurrentBattersAndBowlerDisplayInfo,
    Button,
  },
  setup() {
    // composables
    const eventInjections = useEventInjections()
    const { probableSecondParticipant } = eventInjections
    const { activeParticipant } = useCricketConfiguration()
    const { showBattersAndBowlerInfo, toggleBattersAndBowlerInfoVisibility } =
      useShowBattersAndBowlerSwitch()

    // computed
    const liveViewButtonEnabled = computed(() => {
      const startOverIncidentEnabled =
        resolveStartOverIncidentEnabled(eventInjections)
      const bowlerRunningDisabled =
        resolveBowlerRunningDisabled(eventInjections)

      if (bowlerRunningDisabled.value) {
        return false
      }

      return startOverIncidentEnabled.value === false
    })

    return {
      CricketIncidentId,
      activeParticipant,
      liveViewButtonEnabled,
      probableSecondParticipant,
      toggleBattersAndBowlerInfoVisibility,
      showBattersAndBowlerInfo,
      opChain,
    }
  },
})
</script>

<template>
  <div class="grid content-between gap-4">
    <div class="grid gap-4">
      <IncidentButton
        class="w-full"
        :type="'horizontal'"
        :incidentId="CricketIncidentId.BowlerRunningIn"
        :participantId="opChain(activeParticipant.participant, (v) => v.id)"
        :size="'xl'"
        :color="'white'"
        :disabled="!liveViewButtonEnabled"
      />
      <CurrentBattersAndBowlerSelection
        class="hidden lg:block"
        dir="rtl"
        :participant="probableSecondParticipant"
      />
      <CurrentBattersAndBowlerDisplayInfo
        class="block lg:hidden"
        :participant="probableSecondParticipant"
      />
    </div>
    <Button
      class="block lg:hidden"
      size="md"
      color="blue"
      @click="toggleBattersAndBowlerInfoVisibility()"
    >
      {{ showBattersAndBowlerInfo ? 'Hide' : 'Show' }} Batters and Bowler
    </Button>
  </div>
</template>
